import { authFetch } from '../../api/client';
export async function loadReportPublication(propertyId, publicationId) {
  const response = await authFetch(`/properties/${propertyId}/publications/${publicationId}`);
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(typeof body.detail === 'string' ? body.detail : 'No pudimos cargar el anuncio. Volvé a intentar.');
  }
  return response.json();
}

export async function loadPublicationHistory(id) {
  const response = await authFetch(`/properties/${id}/history`);
  if (!response.ok) throw new Error('No se pudo consultar el historial');
  return response.json();
}
export async function loadAvailability(ids) {
  if (!ids.length) return {};
  const response = await authFetch('/properties/availability', { method: 'POST', body: JSON.stringify({ ids }) });
  if (!response.ok) throw new Error('No se pudo consultar la disponibilidad');
  return response.json();
}
